import PingHandlerActionTypes from './ping-handler.types';

export const startPing = ({ start, end, svg, url, target }) => ({
  type: PingHandlerActionTypes.PING_START,
  payload: { start, end, svg, url, target },
});

export const pingSuccess = (status) => ({
  type: PingHandlerActionTypes.PING_SUCCESS,
  payload: status,
});

export const pingFailure = (error) => ({
  type: PingHandlerActionTypes.PING_FAILURE,
  payload: error,
});

export const startPingById = (start, end, svg, url) => ({
  type: PingHandlerActionTypes.PING_BY_ID_START,
  payload: { start, end, svg, url },
});

export const pingByIdSuccess = (status) => ({
  type: PingHandlerActionTypes.PING_BY_ID_SUCCESS,
  payload: status,
});

export const pingByIdFailure = (error) => ({
  type: PingHandlerActionTypes.PING_BY_ID_FAILURE,
  payload: error,
});

export const setCurrSource = (source) => ({
  type: PingHandlerActionTypes.SET_CURR_SOURCE,
  payload: source,
});

export const setCurrTargets = (targets) => ({
  type: PingHandlerActionTypes.SET_CURR_TARGETS,
  payload: targets,
});
